import { AppRoutes } from './app-routes.constants';

/**
 * Session cookies live on the whole app. Without an explicit path the browser
 * scopes a cookie to the current route's directory, so a cookie set on
 * `/login` (path `/`) could not be deleted from `/seller-portal/...`.
 */
export const SESSION_COOKIE_PATH = '/';

/**
 * Directories where builds before SESSION_COOKIE_PATH left session cookies (the
 * directory of the URL the app was loaded on). A cookie there shadows the `/`
 * one on that route, so ending a session also deletes these.
 * Temporary: remove one release after SESSION_COOKIE_PATH reaches PRD (cookies last 1h).
 */
export const LEGACY_SESSION_COOKIE_PATHS: readonly string[] = [
  `/${AppRoutes.SELLER_PORTAL}`,
  `/${AppRoutes.SELLER_PORTAL}/${AppRoutes.ORDER_DETAIL}`,
  `/${AppRoutes.SELLER_PORTAL}/${AppRoutes.HISTORIC_ORDER_DETAIL}`,
  `/${AppRoutes.SELLER_PORTAL}/${AppRoutes.CLIENT_DETAIL}`,
  `/${AppRoutes.SELLER_DRIVE}`,
];
